module.exports = __webpack_public_path__ + "static/media/arrow-off-sul.65a8eebc.png";